import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Keys, StorageService} from '../../service/storage.service';

@Injectable()
export class ChannelPartnerTransactionIdResolver implements Resolve<void> {
    private readonly storageService: StorageService;

    constructor(storageService: StorageService) {
        this.storageService = storageService;

    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
        const partnerTransactionId = route.params !== undefined ? route.queryParams['transaction-id'] : undefined;
        if (partnerTransactionId) {
            this.storageService.saveObjectToSession(Keys.PARTNER_TRANSACTION_ID, partnerTransactionId);
        }
    }

}
